

export const SSL_DOMAIN = 'www.musicland.co.jp';
export const SHOP_KEY = 'musiclandkey';


export const MYPAGE_LINK = '/fs/musiclandkey/MyPageTop.html';
export const LOGIN_LINK = '/fs/musiclandkey/Login.html';



// WEBPACK FOOTER //
// ./src/js/app/constant/FS2.js